import { TRIPLE_TAP_TIMEOUT_MS, TRIPLE_TAP_CORNER_PX } from '../config.js';

export function startGestureWatcher(onTriggered) {
  let taps = 0;
  let lastTap = 0;
  window.addEventListener('click', (e) => {
    const inCorner =
      e.clientX > window.innerWidth - TRIPLE_TAP_CORNER_PX && e.clientY < TRIPLE_TAP_CORNER_PX;
    if (!inCorner) {
      taps = 0;
      return;
    }
    const now = Date.now();
    if (now - lastTap < TRIPLE_TAP_TIMEOUT_MS) taps += 1;
    else taps = 1;
    lastTap = now;
    if (taps >= 3) {
      taps = 0;
      onTriggered();
    }
  });
}
